import React from "react";
import { GoLocation } from 'react-icons/go';
import { AiOutlinePhone } from 'react-icons/ai';
import { FiMail } from 'react-icons/fi';

const ContactUs = () => {
    return (
      <div className="font-josefin-sans flex justify-center items-center min-h-screen bg-white">
        <div className="w-full mx-3 sm:w-2/3 md:w-1/2 lg:w-1/3 bg-black p-6 sm:p-10 rounded-3xl shadow-xl md:mx-2">
          <h1 className="text-white text-3xl md:text-4xl mb-6 md:mb-8 text-center">
            Contact Us
          </h1>
          <ul className="text-white space-y-4">
            <li className="flex items-start">
              <div className="text-red-500 mr-4">
                <GoLocation size={30} />
              </div>
              <span>
                House No. 481, Second Floor, Shiv Market BLK-WP, Village
                Wazirpur, Ashok Vihar, Delhi-110052
              </span>
            </li>
            <hr className="w-full border-white my-2 md:my-3" />
            <li className="flex items-start">
              <div className="text-red-500 mr-4">
                <AiOutlinePhone size={30} />
              </div>
              <span>Phone: 9650693384</span>
            </li>
            <hr className="w-full border-white my-2 md:my-3" />
            <li className="flex items-start">
              <div className="text-red-500 mr-4">
                <FiMail size={30} />
              </div>
              <span>Email: teamfynii@gmail.com</span>
            </li>
          </ul>
        </div>
      </div>
    );
};

export default ContactUs;
